import moment from "moment";
import { fromAdToBs } from "../../global/function";

// Structural subset shared by both DraftListEntry (draft-item.component.tsx,
// duck-typed local/unsaved drafts) and Draft (drafts.queries.ts, server rows)
// — searching only needs these fields, so this stays independent of either
// concrete type rather than forcing a cast at every call site.
interface SearchableDraft {
	buyer_name?: string | null;
	invoice_number?: string | null;
	sales_date?: string | null;
}

function normalize(value: string): string {
	return value.trim().toLowerCase();
}

export function matchesDraftSearch(
	draft: SearchableDraft,
	query: string,
): boolean {
	const normalizedQuery = normalize(query);
	if (normalizedQuery === "") return true;

	const candidates: string[] = [];
	if (typeof draft.buyer_name === "string") candidates.push(draft.buyer_name);
	if (typeof draft.invoice_number === "string")
		candidates.push(draft.invoice_number);
	if (typeof draft.sales_date === "string" && draft.sales_date) {
		candidates.push(fromAdToBs(draft.sales_date, "DD MMMM, YYYY"));
		candidates.push(moment(draft.sales_date).format("DD MMMM, YYYY"));
	}

	return candidates.some((candidate) =>
		normalize(candidate).includes(normalizedQuery),
	);
}

export function filterDraftsBySearch<T extends SearchableDraft>(
	items: T[],
	query: string,
): T[] {
	if (normalize(query) === "") return items;
	return items.filter((item) => matchesDraftSearch(item, query));
}
